import { useCustomersList } from '@/features/users/customers/hooks/useCustomersList';
import { CustomersTable } from '@/features/users/customers/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'rewardPoints',
    'mobileNumber',
    'emailAddress',
    'customerInfo',
    'status',
    'createdDate',
    'updatedDate',
    'referrer',
  ]),
  desc: z.boolean(),
});

const CustomersSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z
    .string()

    .optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
    .optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/users/customers/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => CustomersSearchSchema.parse(search),
});

function RouteComponent() {
  const { customers, meta, isLoading } = useCustomersList();
  return <CustomersTable data={customers} pagination={meta} isLoading={isLoading} />;
}
